import React from 'react'
import { connect } from 'react-redux'
import { change, Field, getFormValues, reduxForm } from 'redux-form'
import { Container } from './styled'
import { useNavigate,useParams } from "react-router-dom";
import TextInput from 'components/TailwindForm/TextInput'
import StandardButton from 'components/Shareds/StandardButton'
// import { userLogIn } from 'ducks/authenticate';
// import { resetPasswordPath } from 'routes';
import { loginRequest } from 'core/authConfig'
import LabelOnly from 'components/TailwindForm/LabelOnly';
import { getTextResult, textKey } from 'core/textResult'
import { toastClear } from 'ducks/app';

const Login = (props) => {
    const { valueForm, userLogIn, accessToken, user,toastClear } = props
    const history = useNavigate()
    const { id } = useParams()
    React.useEffect(() => {
        toastClear(""); 
        if (!localStorage.getItem('language')) {
          localStorage.setItem('language', "en");
        }
      
      }, [])

    return (
        <Container className='App h-full'>
            <div className="flex flex-col items-center justify-center w-full">
                {/* Icon */}
                <div className="">
                    {/* ใส่รูปไอคอนตรงนี้ */}
                    <img src="/Completed.svg" alt="Success Icon" className="w-16 h-16 lg:w-32 lg:h-32" />
                </div>

                {/* Title */}
                <h1 className="text-2xl font-bold mb-2">{getTextResult(textKey.SUCCESS1)}</h1>

                {/* Reference Number */}
                <p className="text-gray-700 mb-6">{getTextResult(textKey.SUCCESS2)}<span className="font-semibold ml-2">{id}</span></p>

            </div>


        </Container>

    )
}


const mapStateToProps = (state) => {
    return {
        valueForm: getFormValues('formLogin')(state),
        // user: state.authenticate.user,
        // accessToken: state.authenticate.user.accessToken,

    }
}

const mapDispatchToProps = {
    // userLogIn,
    toastClear

}
const LoginForm = reduxForm({
    form: 'formLogin',
    enableReinitialize: true,
})(Login)

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)

